import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  tabs: {
    marginBottom: pxToRem(26),
    selectors: {
      [layout.breakpoints.min.md]: {
        marginBottom: '2rem',
      },
      [layout.breakpoints.min.lg]: {
        marginBottom: pxToRem(24),
      },
    },
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(20),
    fontWeight: 400,
  },
});
